<form>
  <div class="modal-header">
    <h4 class="modal-title">Options</h4>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label for="Input1">Route Name</label>
      <input class="form-control w-50" id="Input1" />
    </div>
    <div class="accordion thead-light" id="accordionCodeExample">
      <div class="card">
        <div
          class="card-header"
          id="accordionHeadingOne"
          data-toggle="collapse"
          data-target="#codeCollapseOne"
          aria-expanded="true"
          aria-controls="codeCollapseOne"
        >
          <h6 class="mb-0" id="collapsible-group-item-1">
            Routing Preferences
          </h6>
        </div>
        <div
          id="codeCollapseOne"
          class="collapse bg-gray-light show"
          aria-labelledby="accordionHeadingOne"
          data-parent="#accordionCodeExample"
        >
          <div class="card-body">
            <div class="form-row">
              <div class="col">
                <label for="routeType1">Route Type</label>
                <select class="custom-select form-control" id="routetype">
                  <option></option>
                </select>
              </div>

              <div class="col">
                <label for="network1">Road Network</label>
                <select class="custom-select form-control" id="network">
                  <option></option>
                </select>
              </div>
              <div class="col">
                <label for="roads1">Roads</label>
                <select class="custom-select form-control" id="roads">
                  <option></option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="col">
                <label for="tolls1">Toll Roads</label>
                <select class="custom-select form-control" id="tolls">
                  <option></option>
                </select>
              </div>
              <div class="col">
                <label for="borders1">International Borders</label>
                <select class="custom-select form-control" id="borders">
                  <option></option>
                </select>
              </div>
              <div class="col">
                <label for="borders1">Restrictions</label>
                <select
                  class="custom-select form-control"
                  id="overrideRestrict"
                >
                  <option></option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="col">
                <label for="ferries1">Ferries</label>
                <select class="custom-select form-control" id="ferries">
                  <option></option>
                </select>
              </div>
              <div class="col">
                <label for="hub1">Hub Routing</label>
                <select class="custom-select form-control" id="hubRouting">
                  <option></option>
                </select>
              </div>
              <div class="col">
                <label for="side1">Side of Street Adherence</label>
                <select
                  class="custom-select form-control"
                  id="sideOfStreetAdherence"
                >
                  <option></option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="col">
                <label for="side1">Governor Speed Limiting</label>
                <div class="d-flex flex-row">
                  <select
                    class="custom-select form-control"
                    id="governorSpeedLimits"
                  >
                    <option></option>
                  </select>
                  <input id="side2" class="w-10 mx-1 mb-1" disabled />
                  <p style="color: #808080">lbs/gallon</p>
                </div>
              </div>
              <div class="col">
                <label for="side3">Elevation</label>
                <div class="d-flex flex-row">
                  <select class="custom-select form-control" id="elevLimit">
                    <option></option>
                  </select>
                  <input id="side4" class="mx-1 mb-1" disabled />
                  <p style="color: #808080">mph</p>
                </div>
              </div>
              <div class="col">
                <label for="hazmat1">Hazmat</label>
                <select class="custom-select form-control" id="hazmat">
                  <option></option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="col w-25">
                <label for="site1">Site routing</label>
                <select class="custom-select form-control" id="sitess">
                  <option></option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div
          class="card-header"
          id="accordionHeadingTwo"
          data-toggle="collapse"
          data-target="#codeCollapseTwo"
          aria-expanded="false"
          aria-controls="codeCollapseTwo"
        >
          <h6 class="mb-0" id="collapsible-group-item-2">Route Modifiers</h6>
        </div>
        <div
          id="codeCollapseTwo"
          class="collapse bg-gray-light"
          aria-labelledby="accordionHeadingTwo"
          data-parent="#accordionCodeExample"
        >
          <div class="card-body">
            <div class="form-row align-items-center">
              <div class="col-auto">
                <label class="sr-only" for="inlineFormInputGroup"
                  >Username</label
                >
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <h5>Sets</h5>
                    <br />
                    <div class="input-group-icon modus-icons">filter</div>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="Filtering"
                    placeholder="Filter"
                  />
                  <div class="input-group-icon modus-icons">
                    circle_close_outline
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div
          class="card-header"
          id="accordionHeadingThree"
          data-toggle="collapse"
          data-target="#codeCollapseThree"
          aria-expanded="false"
          aria-controls="codeCollapseThree"
        >
          <h6 class="mb-0" id="collapsible-group-item-3">Vehicle Dimensions</h6>
        </div>
        <div
          id="codeCollapseThree"
          class="collapse bg-gray-light"
          aria-labelledby="accordionHeadingThree"
          data-parent="#accordionCodeExample"
        >
          <div class="card-body">
            <div class="form-row">
              <label for="network1">Vehicle Type</label>
              <select class="custom-select form-control" id="vehicletype">
                <option></option>
              </select>
            </div>
            <div class="form-row">
              <div class="col">
                <label for="height">Height</label>
                <input
                  type="number"
                  id="height"
                  class="form-control"
                  aria-describedby="passwordHelpInline"
                />
                <small id="passwordHelpInline" class="text-muted">ft</small>
              </div>
              <div class="col">
                <label>Inches</label>
                <input
                  type="number"
                  id="inch1"
                  class="form-control w-25"
                  aria-describedby="passwordHelpInline"
                />

                <small id="inchs1" class="text-muted">in</small>
              </div>
              <div class="col">
                <label for="length">Length</label>
                <input
                  type="number"
                  id="length"
                  class="form-control"
                  aria-describedby="passwordHelpInline"
                />

                <small id="len1" class="text-muted">ft</small>
              </div>
              <div class="col">
                <label>Inches</label>
                <input
                  type="number"
                  id="inch2"
                  class="form-control w-25"
                  aria-describedby="passwordHelpInline"
                />
                <small id="inchs2" class="text-muted">in</small>
              </div>
              <div class="col">
                <label for="width">Width</label>
                <input
                  type="number"
                  id="width"
                  class="form-control"
                  aria-describedby="passwordHelpInline"
                />
                <small id="len1" class="text-muted">in</small>
              </div>
            </div>
            <div class="form-row">
              <div class="col">
                <label for="wid">Weight</label>
                <input
                  type="number"
                  id="wid"
                  class="form-control w-50"
                  aria-describedby="passwordHelpInline"
                />
                <small id="len1" class="text-muted">in</small>
              </div>
              <div class="col">
                <label for="network1">Axles</label>
                <select class="custom-select form-control" id="axle">
                  <option></option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div
          class="card-header"
          id="accordionHeadingFour"
          data-toggle="collapse"
          data-target="#codeCollapseFour"
          aria-expanded="false"
          aria-controls="codeCollapseFour"
        >
          <h6 class="mb-0" id="collapsible-group-item-3">
            Reporting Preferences
          </h6>
        </div>
        <div
          id="codeCollapseFour"
          class="collapse bg-gray-light"
          aria-labelledby="accordionHeadingFour"
          data-parent="#accordionCodeExample"
        >
          <div class="card-body">
            <div class="form-group w-25">
              <label for="exampleFormControlSelect1">Report Data Version</label>
              <select
                class="custom-select form-control"
                id="exampleFormControlSelect2"
              >
                <option></option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div
          class="card-header"
          id="accordionHeadingFive"
          data-toggle="collapse"
          data-target="#codeCollapseFive"
          aria-expanded="false"
          aria-controls="codeCollapseFive"
        >
          <h6 class="mb-0" id="collapsible-group-item-3">
            Arrival & Departure
          </h6>
        </div>
        <div
          id="codeCollapseFive"
          class="collapse bg-gray-light"
          aria-labelledby="accordionHeadingFive"
          data-parent="#accordionCodeExample"
        >
          <div class="card-body">
            <!-- TODO: add date input field -->
            <div class="form-row">
              <div class="col">
                <label for="arr">Arrival/Departure</label>
                <select class="custom-select form-control" id="arr">
                  <option></option>
                </select>
              </div>
              <div class="col">
                <label for="day">Day/Date</label>
                <select class="custom-select form-control" id="day">
                  <option></option>
                </select>
                <select class="custom-select form-control" id="date">
                  <option></option></select
                ><br />
                <label for="day">Time of the Day</label>
                <input
                  type="string"
                  class="form-control w-60"
                  value="10:05AM"
                />
              </div>
              <div class="col">
                <label for="arr">Travel Speeds</label>
                <select class="custom-select form-control" id="speeds">
                  <option></option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-2">
      <p class="small text-right mb-0">
        Additional options are available in
        <a href="Application">Application Settings</a>
      </p>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-link mr-auto">Save as Default Options</button>
    <button class="btn btn-outline-dark mr-2">Cancel</button>
    <button type="submit" class="btn btn-primary">Save</button>
  </div>
</form>
